@if (contentlet$ | async; as contentlet) { @if (contentlet.url) {
<div class="video-container default-video-class vimeo-video" [ngClass]="getVideoClasses(contentlet)">
  <div
    [ngClass]="(getVideoHeight$(contentlet) | async) ? 'video-wrapper custom-video-wrapper' : 'video-wrapper'"
    [ngStyle]="{ 'height.px': (getVideoHeight$(contentlet) | async) }"
  >
    @if (iframeVideoUrl(contentlet); as url) {
    <iframe [title]="contentlet?.title" [src]="url" frameborder="0" allow="autoplay *;" allowfullscreen></iframe>
    }
  </div>
</div>
} }
